import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6d1c88a4")

_pushScopeId("data-v-6d1c88a4")
const _hoisted_1 = { class: "flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", {
  "aria-hidden": "true",
  class: "fixed inset-0 transition-opacity",
  title: "overlay_for_confirm"
}, [
  /*#__PURE__*/_createVNode("div", { class: "absolute inset-0 backdrop-filter backdrop-blur-xl" })
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("span", {
  "aria-hidden": "true",
  class: "hidden sm:inline-block sm:align-middle sm:h-screen"
}, "​", -1)
const _hoisted_4 = {
  class: "min-h-[36rem] z-0 w-full inline-block min-h-full align-bottom bg-white dark:bg-gray-900 rounded-3xl text-left shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full",
  style: {"width":"-moz-available"}
}
const _hoisted_5 = {
  key: 0,
  class: "float-right  -mr-6 -mt-1"
}
const _hoisted_6 = {
  key: 1,
  class: "float-right  -mr-6 -mt-1"
}
const _hoisted_7 = { class: "overflow-hidden relative rounded-3xl" }
const _hoisted_8 = {
  id: "modal-subscribeTitle",
  class: "mt-6 py-4 text-center text-3xl leading-6 font-medium text-bp-light",
  style: {"margin-bottom":"-4px"}
}
const _hoisted_9 = {
  "aria-labelledby": "modal-headline",
  "aria-modal": "true",
  role: "dialog"
}
const _hoisted_10 = { class: "m-4 mb-2 mt-0 space-y-4" }
const _hoisted_11 = { class: "m-4 -mt-4" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { key: 2 }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_btn_close = _resolveComponent("btn-close")
  const _component_btn_edit = _resolveComponent("btn-edit")
  const _component_subscribe_header = _resolveComponent("subscribe-header")
  const _component_CheckoutNavBar = _resolveComponent("CheckoutNavBar")
  const _component_DangerAlert = _resolveComponent("DangerAlert")
  const _component_UserInformationStep1 = _resolveComponent("UserInformationStep1")
  const _component_channel_activation_step2 = _resolveComponent("channel-activation-step2")
  const _component_subscribe_step3 = _resolveComponent("subscribe-step3")

  return _withDirectives((_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode("div", _hoisted_4, [
      (_ctx.isAllowedToCloseBoostpack())
        ? (_openBlock(), _createBlock("div", _hoisted_5, [
            _createVNode(_component_btn_close, {
              "css-class": "absolute z-20",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.cancelDialog()))
            })
          ]))
        : _createCommentVNode("", true),
      (_ctx.isAllowedToGoBack())
        ? (_openBlock(), _createBlock("div", _hoisted_6, [
            _createVNode(_component_btn_edit, {
              "btn-icon": "return_icon",
              "css-class": "absolute z-20",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.goBack()))
            })
          ]))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_7, [
        _withDirectives(_createVNode("div", null, [
          _createVNode(_component_subscribe_header)
        ], 512), [
          [_vShow, _ctx.showHeader]
        ]),
        _createVNode("h3", _hoisted_8, _toDisplayString(_ctx.$t("modal.SubscribeDialog.subscribeTitle")), 1),
        _createVNode("div", _hoisted_9, [
          _withDirectives(_createVNode("div", _hoisted_10, [
            _createVNode(_component_CheckoutNavBar, {
              steps: _ctx.steps,
              "current-step": _ctx.activeStep,
              onUpdateStep: _ctx.changeStep
            }, null, 8, ["steps", "current-step", "onUpdateStep"])
          ], 512), [
            [_vShow, _ctx.showHeader]
          ]),
          _withDirectives(_createVNode("div", _hoisted_11, [
            _createVNode(_component_DangerAlert, {
              "error-message": _ctx.errorMessage,
              "error-title": _ctx.errorTitle,
              "show-title": true
            }, null, 8, ["error-message", "error-title"]),
            (_ctx.activeStep === 1)
              ? (_openBlock(), _createBlock("div", _hoisted_12, [
                  _createVNode(_component_UserInformationStep1, {
                    onOnSuccess: _ctx.goToNextStep,
                    onOnError: _ctx.showError,
                    savedSubscriptionData: _ctx.subscriptionData,
                    onUpdateSelectedChannel: _ctx.updateSelectedChannel
                  }, null, 8, ["onOnSuccess", "onOnError", "savedSubscriptionData", "onUpdateSelectedChannel"])
                ]))
              : (_ctx.activeStep === 2)
                ? (_openBlock(), _createBlock("div", _hoisted_13, [
                    _createVNode(_component_channel_activation_step2, {
                      subscriptionData: _ctx.subscriptionData,
                      currentSelectedChannel: _ctx.selectedChannel,
                      "boostpack-id": _ctx.subscriptionData.boostpackId,
                      onOnSuccess: _ctx.goToNextStep,
                      onOnError: _ctx.showError,
                      onUpdateSubscribeData: _ctx.updateSubscribeData
                    }, null, 8, ["subscriptionData", "currentSelectedChannel", "boostpack-id", "onOnSuccess", "onOnError", "onUpdateSubscribeData"])
                  ]))
                : (_ctx.activeStep === 3)
                  ? (_openBlock(), _createBlock("div", _hoisted_14, [
                      _createVNode(_component_subscribe_step3, {
                        "has-errors": _ctx.hasErrors,
                        onCloseCheckout: _ctx.cancelDialog,
                        subscriptionData: _ctx.subscriptionData
                      }, null, 8, ["has-errors", "onCloseCheckout", "subscriptionData"])
                    ]))
                  : _createCommentVNode("", true)
          ], 512), [
            [_vShow, !_ctx.showAd]
          ])
        ])
      ])
    ])
  ], 512)), [
    [_vShow, _ctx.checkoutVisible]
  ])
})